import * as Yup from "yup";

export const ProfessionSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  status: Yup.boolean().required("Status is required"),
});
